
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {QrcodeStream} from "vue-qrcode-reader";

@Component({
  components: {
    QrcodeStream,
  },
})

export default class VueQrcodeReaderVanilla extends Vue {

  private onDecode(decodedString: string): void {
    if (decodedString) {
      this.$emit("decode", decodedString);
    }
  }
}
